/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type RevokeInvoiceLineApprovalMutationVariables = Types.Exact<{
  invoiceLineIds: Array<Types.InputMaybe<Types.Scalars['Long']['input']>>;
}>;


export type RevokeInvoiceLineApprovalMutation = {
  __typename?: 'Mutation',
  revokeInvoiceLineApproval?: string | null
};

export type DeleteInvoiceLineMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type DeleteInvoiceLineMutation = {
  __typename?: 'Mutation',
  deleteInvoiceline?: {
    __typename?: 'InvoiceLine',
    id: number
  } | null
};

export type DeleteDeclarationMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type DeleteDeclarationMutation = {
  __typename?: 'Mutation',
  deleteDeclaration?: string | null
};

export type ReadyFinanciallyMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type ReadyFinanciallyMutation = {
  __typename?: 'Mutation',
  readyFinancially?: {
    __typename?: 'PurchaseDeclaration',
    id: number
  } | {
    __typename?: 'SalesDeclaration',
    id: number
  } | null
};

export type UnreadyFinanciallyMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type UnreadyFinanciallyMutation = {
  __typename?: 'Mutation',
  unreadyFinancially?: {
    __typename?: 'PurchaseDeclaration',
    id: number
  } | {
    __typename?: 'SalesDeclaration',
    id: number
  } | null
};

export type CloseDeclarationMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type CloseDeclarationMutation = {
  __typename?: 'Mutation',
  close?: {
    __typename?: 'PurchaseDeclaration',
    id: number
  } | {
    __typename?: 'SalesDeclaration',
    id: number
  } | null
};

export type OpenDeclarationMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Long']['input']>;
}>;


export type OpenDeclarationMutation = {
  __typename?: 'Mutation',
  open?: {
    __typename?: 'PurchaseDeclaration',
    id: number
  } | {
    __typename?: 'SalesDeclaration',
    id: number
  } | null
};

export type DeclareWithRemarkMutationVariables = Types.Exact<{
  input: Types.DeclareInput;
  remark?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type DeclareWithRemarkMutation = {
  __typename?: 'Mutation',
  declare?: {
    __typename?: 'PurchaseDeclaration',
    id: number
  } | {
    __typename?: 'SalesDeclaration',
    id: number
  } | null
};


export const RevokeInvoiceLineApprovalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeInvoiceLineApproval"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invoiceLineIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeInvoiceLineApproval"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"invoiceLineIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invoiceLineIds"}}}]}]}}]} as unknown as DocumentNode<RevokeInvoiceLineApprovalMutation, RevokeInvoiceLineApprovalMutationVariables>;
export const DeleteInvoiceLineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInvoiceLine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteInvoiceline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteInvoiceLineMutation, DeleteInvoiceLineMutationVariables>;
export const DeleteDeclarationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDeclaration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDeclaration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteDeclarationMutation, DeleteDeclarationMutationVariables>;
export const ReadyFinanciallyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReadyFinancially"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"readyFinancially"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReadyFinanciallyMutation, ReadyFinanciallyMutationVariables>;
export const UnreadyFinanciallyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnreadyFinancially"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unreadyFinancially"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UnreadyFinanciallyMutation, UnreadyFinanciallyMutationVariables>;
export const CloseDeclarationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CloseDeclaration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"close"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CloseDeclarationMutation, CloseDeclarationMutationVariables>;
export const OpenDeclarationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OpenDeclaration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"open"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OpenDeclarationMutation, OpenDeclarationMutationVariables>;
export const DeclareWithRemarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeclareWithRemark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeclareInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"remark"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"declare"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"declareInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"remark"},"value":{"kind":"Variable","name":{"kind":"Name","value":"remark"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeclareWithRemarkMutation, DeclareWithRemarkMutationVariables>;